var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.location)?_c('l-marker',{attrs:{"lat-lng":_vm.latLng()},on:{"mouseover":_vm.pinHoverEnter,"mouseleave":_vm.pinHoverLeave,"click":_vm.showFleetVehicleDetails}},[_c('l-icon',{attrs:{"icon-url":_vm.icon,"icon-size":_vm.iconSize,"className":"pwt-car-shadow"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }